import React from 'react';
import PropTypes from 'prop-types';
import styled, { keyframes } from 'styled-components';

const float = keyframes`
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-4px);
  }
`;

const glow = keyframes`
  0%, 100% {
    opacity: 0.6;
  }
  50% {
    opacity: 1;
  }
`;

const AnimatedSvg = styled.svg`
  display: block;
  height: auto;
  width: 100%;

  .rocket-body {
    animation: ${float} 2.5s ease-in-out infinite;
    transform-origin: center center;
  }

  .flame {
    animation: ${glow} 1.5s ease-in-out infinite;
  }
`;

export default function TeamAssistEmptyStateIcon({ className, size = 120 }) {
  return (
    <AnimatedSvg className={className} height={size} viewBox="0 0 80 100" width={size}>
      {/* Rocket body */}
      <g className="rocket-body">
        {/* Main body */}
        <path d="M40 8 L48 42 L48 92 L32 92 L32 42 Z" fill="currentColor" opacity="0.9" />
        {/* Window */}
        <circle cx="40" cy="32" fill="currentColor" opacity="0.3" r="6" />
        {/* Left fin */}
        <path d="M32 50 L20 92 L32 92 Z" fill="currentColor" opacity="0.7" />
        {/* Right fin */}
        <path d="M48 50 L60 92 L48 92 Z" fill="currentColor" opacity="0.7" />
        {/* Flame / exhaust */}
        <g className="flame">
          <path d="M36 88 L40 100 L44 88 Z" fill="currentColor" opacity="0.8" />
          <path d="M38 92 L40 98 L42 92 Z" fill="currentColor" opacity="0.5" />
        </g>
      </g>
    </AnimatedSvg>
  );
}

TeamAssistEmptyStateIcon.propTypes = {
  className: PropTypes.string,
  size: PropTypes.number,
};
